export default {
  computed: {
    $typeBindingOptions() {
      return [
        { value: "allowmeto", text: "allow me to" },
        { value: "isrequiredfor", text: "is required for" },
        { value: "helpsmeto", text: "helps me to" },
        { value: "givesme", text: "gives me" }
      ];
    }
  }
};
